/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

import {
    getLabelTipoCartaoEnum,
    TipoCartaoEnum,
} from "../../../model/Enums/TipoCartaoEnum";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import InputTime from "../../../components/InputTime";

const { BtnPrimary } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

interface IFormIntradayProps {
    onSubmit: (callback: any) => void;
}

function FormIntraday(props: IFormIntradayProps) {
    const [time, setTime] = useState<string>("00:15");

    const handleTimeChange = (value: string) => {
        setTime(value);
    };

    const checkIfTimeIsFulfilled = (): boolean => {
        const [hours, minutes] = time.split(":");

        return !(Number(hours) === 0 && Number(minutes) < 15);
    };

    const handleSubmit = () => {
        if (checkIfTimeIsFulfilled()) {
            props.onSubmit({
                title: getLabelTipoCartaoEnum(TipoCartaoEnum.Intrajornada),
                duracaoHoraAula: time,
            });
        }
    };

    const isTimeFilled = time.length === 5;

    return (
        <>
            <Row className="mt-3">
                <Col className="field col-12 md:col-4">
                    <span className="p-float-label">
                        <InputTime
                            value={time}
                            onChange={handleTimeChange}
                            minValue="00:15"
                            maxValue="02:00"
                            id="time"
                            className="p-filled"
                        />
                        <label htmlFor="time">Duração HH:MM</label>
                    </span>
                </Col>
            </Row>
            <StyledContainerButton className="mt-3">
                <BtnPrimary disabled={!isTimeFilled} onClick={handleSubmit}>
                    Criar
                </BtnPrimary>
            </StyledContainerButton>
        </>
    );
}

export default FormIntraday;
